// extracted by mini-css-extract-plugin
module.exports = {"projects":"index_projects___C78U","intro":"index_intro__4bc1l"};